<script>
export default {
	name: 'kontofilter-dropdown',
	methods: {
		click_Item (item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse (evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem (value) {
			this.selectedItems = [];
			for (let item of this.getItems) {
				if (this.multiselect) {
					if (value) {
						if (value === item.value) {
							item.active = !item.active;
						}
					} else {
						item.active = false;
					}
				} else {
					if (value) {
						if (value === item.value) {
							item.active = true;
						} else {
							item.active = false;
						}
					} else {
						item.active = false;
					}
				}
				if (item.active) {
					this.selectedItems.push(item);
				}
			}
			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear () {
			this.selectItem();
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		selectedTitle () {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		},
		getItems () {
			if (this.user.role === 4 || this.user.role === 5) {
				// return all items
				return this.items;
			} else {
				// don't return admin items
				return this.items.filter(item => !item.admin_only);
			}
		}
	},
	data: () => {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [
				{
					label: '00004P',
					value: '00004P',
					admin_only: false,
					active: false
				},
				{
					label: '900033',
					value: '900033',
					admin_only: false,
					active: false
				},
				{
					label: '900089',
					value: '900089',
					admin_only: false,
					active: false
				},
				{
					label: '906276',
					value: '906276',
					admin_only: false,
					active: false
				},
				{
					label: 'CENNM',
					value: 'CENNM',
					admin_only: false,
					active: false
				},
				{
					label: 'RV0KM',
					value: 'RV0KM',
					admin_only: true,
					active: false
				},
				{
					label: 'RV0KMD',
					value: 'RV0KMD',
					admin_only: false,
					active: false
				},
				{
					label: 'RV2KM2',
					value: 'RV2KM2',
					admin_only: true,
					active: false
				},
				{
					label: 'RV2KMD',
					value: 'RV2KMD',
					admin_only: false,
					active: false
				},
				{
					label: 'TV',
					value: 'TV',
					admin_only: false,
					active: false
				},
				{
					label: 'ND',
					value: 'ND',
					admin_only: false,
					active: false
				},
				{
					label: '000001',
					value: '000001',
					admin_only: false,
					active: false
				},
				{
					label: '000005',
					value: '000005',
					admin_only: false,
					active: false
				},
				{
					label: '110032',
					value: '110032',
					admin_only: false,
					active: false
				},
				{
					label: '110042',
					value: '110042',
					admin_only: false,
					active: false
				},
				{
					label: '906089',
					value: '906089',
					admin_only: false,
					active: false
				},
				{
					label: 'Brez',
					value: '#',
					admin_only: false,
					active: false
				}
			]
		}
	}
}
</script>
<template>
<b-dropdown :text="selectedTitle" ref="dropdown">
	<b-dropdown-header>Konto</b-dropdown-header>
	<b-dropdown-item @click="click_Item(item)" v-for="item in getItems" :key="item.value" :active="item.active">
		{{ item.label }}
	</b-dropdown-item>
	<b-dropdown-divider></b-dropdown-divider>
	<b-dropdown-item @click="click_Vse" :active="allSelected">{{ defaultItemLabel }}</b-dropdown-item>
</b-dropdown>
</template>
<style>
</style>



// WEBPACK FOOTER //
// src/components/KontoDestinacijeFilterDropdown.vue